/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type GenderEnum = (typeof GenderEnum)[keyof typeof GenderEnum];

export const GenderEnum = {
  m: 'm',
  f: 'f',
} as const;
